// Credentials are never trimmed: altering a password silently changes what the user typed.
const NEVER_TRIMMED = ["password", "newPassword", "currentPassword", "confirmPassword"];

// Strips whitespace a reader typed around a value, so the field shows what will be stored.
// Whitespace-only input becomes "" so the form's existing required check rejects it.
// @since NEXT_VERSION
export const trimOnBlur = (setData, field) => (event) => {
  const value = event?.target?.value;
  if (typeof value !== "string") return;

  const trimmed = value.trim();
  // Skips the state update when nothing was padded, to avoid a needless re-render.
  if (trimmed === value) return;

  setData((previous) => {
    if (process.env.NODE_ENV !== "production" && previous && !(field in previous)) {
      // A mistyped name would quietly add a new key and trim nothing, so say so while developing.
      console.warn(`trimOnBlur: "${field}" is not a field on this form`);
    }
    return { ...previous, [field]: trimmed };
  });
};

// Trims each top-level text value on a form payload, so what is stored matches what the reader
// sees however the value arrived — typed, loaded for editing, or filled in by the browser.
// Call it where the form builds its payload, so validation runs against the trimmed values too.
// @since NEXT_VERSION
export const trimTextFields = (data) => {
  // Arrays are returned untouched: rebuilding one here would turn it into an object.
  if (!data || typeof data !== "object" || Array.isArray(data)) return data;

  return Object.fromEntries(
    Object.entries(data).map(([key, value]) =>
      typeof value === "string" && !NEVER_TRIMMED.includes(key)
        ? [key, value.trim()]
        : [key, value]
    )
  );
};
